export default "/images/logo-vl.svg?c24ac77d0fd2d5bfd533a4e45eb94c32";